import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

// reducer import
import customizationReducer from './customizationReducer';
import userReducer from './userReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const initialState = {};

const middleware = [thunk];

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? compose
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const reducers = combineReducers({
  customization: customizationReducer,
  user: userReducer
});

const store = createStore(reducers, initialState, enhancer);

export default store;
